function gtag() {(window['dataLayer'] = window['dataLayer'] || []).push(arguments)}

function implementExperiment(value, name) {
	console.log(value);
  if (value ==  '0') {
    setupExp('none');
  }
}
gtag('event', 'optimize.callback', {
    callback: implementExperiment
 });
function setupExp(exp)
{
	if(typeof exp_timeout != 'undefined')
		clearInterval(exp_timeout);
	var $=jQuery;

	var current=$('.variation-holder').get(0);
	var target=$('.variation-holder.'+exp);
	if(target.length>0)
	{
		$('.variation-holder').not(target).remove();
		target.removeClass('hidden');
	}
	else
	{
		$('.variation-holder').not($('.variation-holder').get(0)).remove();
	}
	var css = document.createElement('style');
	css.type = 'text/css';
	var styles = '.variation-holder { opacity:1; }';
	if (css.styleSheet) css.styleSheet.cssText = styles;
	else css.appendChild(document.createTextNode(styles));
	document.getElementsByTagName("head")[0].appendChild(css);

	$(function(){
		$('.header .top-right .icon').click(function(){
			$(this).toggleClass('active');
			$(this).siblings('.info').slideToggle();
		});
		$('.header .show-more-info').click(function(e){
			e.preventDefault();
			$.magnificPopup.open({
	          items: {
	              src: '.more-info.popup',
	              type: 'inline'
	          },
	          removalDelay: 300,
	          mainClass: 'mfp-fade'
	        });
		});
		$('.header .show-get-help').click(function(e){
			e.preventDefault();
			$.magnificPopup.open({
	          items: {
	              src: '.get-help.popup',
	              type: 'inline'
	          },
	          removalDelay: 300,
	          mainClass: 'mfp-fade'
	        });
		});
	});
}
if(typeof variation == 'undefined')
	setupExp('none');//bypass for non experiment pages

jQuery( document ).ready(function($) {
	$('a[data-action]').click(function(){
		var action=$(this).data('action');
		if(typeof ga != "undefined")
			ga('send', 'event', 'click', action);
		else
			console.log(action);
	});
});

